import { Coordinate } from "ol/coordinate";
import { PlanEvents, VesselPlanningModel } from "../../src/models/vessel-planning-model";

export const MOCK_DATA = {
 "parametric_roll_risk_polygons_wave": [
   [
     [
       7.446316324487581,
       30.00000000000001
     ],
     [
       0,
       0
     ],
     [
       7.446316324487581,
       150
     ],
     [
       7.446316324487581,
       30.00000000000001
     ]
   ],
   [
     [
       9.079593969842987,
       -150
     ],
     [
       0,
       0
     ],
     [
       9.079593969842987,
       -30.00000000000001
     ],
     [
       9.079593969842987,
       -150
     ]
   ]
 ],
 "parametric_roll_risk_polygons_swell": [],
 "resonant_roll_risk_polygons_wave": [
   [
     [
       28.0875499493219,
       -152.8825564081272
     ],
     [
       28.0875499493219,
       -27.117443591872807
     ],
     [
       32.69195655165249,
       -40.118436568896314
     ],
     [
       32.69195655165249,
       -139.8815634311037
     ],
     [
       28.0875499493219,
       -152.8825564081272
     ]
   ]
 ],
 "resonant_roll_risk_polygons_swell": [],
 "minimum_speed_polygon": [
   [
     8.175643089894143,
     0
   ],
   [
     8.175643089894143,
     1
   ],
   [
     8.175643089894143,
     2
   ],
   [
     8.175643089894143,
     3
   ],
   [
     8.175643089894143,
     4
   ],
   [
     8.175643089894143,
     5
   ],
   [
     8.175643089894143,
     6
   ],
   [
     8.175643089894143,
     7
   ],
   [
     8.175643089894143,
     8
   ],
   [
     8.175643089894143,
     9
   ],
   [
     8.175643089894143,
     10
   ],
   [
     8.175643089894143,
     11
   ],
   [
     8.175643089894143,
     12
   ],
   [
     8.175643089894143,
     13
   ],
   [
     8.175643089894143,
     14
   ],
   [
     8.175643089894143,
     15
   ],
   [
     8.175643089894143,
     16
   ],
   [
     8.175643089894143,
     17
   ],
   [
     8.175643089894143,
     18
   ],
   [
     8.175643089894143,
     19
   ],
   [
     8.175643089894143,
     20
   ],
   [
     8.175643089894143,
     21
   ],
   [
     8.175643089894143,
     22
   ],
   [
     8.175643089894143,
     23
   ],
   [
     8.175643089894143,
     24
   ],
   [
     8.175643089894143,
     25
   ],
   [
     8.175643089894143,
     26
   ],
   [
     8.175643089894143,
     27
   ],
   [
     8.175643089894143,
     28
   ],
   [
     8.175643089894143,
     29
   ],
   [
     8.175643089894143,
     30
   ],
   [
     8.175643089894143,
     31
   ],
   [
     8.175643089894143,
     32
   ],
   [
     8.175643089894143,
     33
   ],
   [
     8.175643089894143,
     34
   ],
   [
     8.175643089894143,
     35
   ],
   [
     8.175643089894143,
     36
   ],
   [
     8.175643089894143,
     37
   ],
   [
     8.175643089894143,
     38
   ],
   [
     8.175643089894143,
     39
   ],
   [
     8.175643089894143,
     40
   ],
   [
     8.175643089894143,
     41
   ],
   [
     8.175643089894143,
     42
   ],
   [
     8.175643089894143,
     43
   ],
   [
     8.175643089894143,
     44
   ],
   [
     8.175643089894143,
     45
   ],
   [
     8.175643089894143,
     46
   ],
   [
     8.175643089894143,
     47
   ],
   [
     8.175643089894143,
     48
   ],
   [
     8.175643089894143,
     49
   ],
   [
     8.175643089894143,
     50
   ],
   [
     8.175643089894143,
     51
   ],
   [
     8.175643089894143,
     52
   ],
   [
     8.175643089894143,
     53
   ],
   [
     8.175643089894143,
     54
   ],
   [
     8.175643089894143,
     55
   ],
   [
     8.175643089894143,
     56
   ],
   [
     8.175643089894143,
     57
   ],
   [
     8.175643089894143,
     58
   ],
   [
     8.175643089894143,
     59
   ],
   [
     8.175643089894143,
     60
   ],
   [
     8.175643089894143,
     61
   ],
   [
     8.175643089894143,
     62
   ],
   [
     8.175643089894143,
     63
   ],
   [
     8.175643089894143,
     64
   ],
   [
     8.175643089894143,
     65
   ],
   [
     8.175643089894143,
     66
   ],
   [
     8.175643089894143,
     67
   ],
   [
     8.175643089894143,
     68
   ],
   [
     8.175643089894143,
     69
   ],
   [
     8.175643089894143,
     70
   ],
   [
     8.175643089894143,
     71
   ],
   [
     8.175643089894143,
     72
   ],
   [
     8.175643089894143,
     73
   ],
   [
     8.175643089894143,
     74
   ],
   [
     8.175643089894143,
     75
   ],
   [
     8.175643089894143,
     76
   ],
   [
     8.175643089894143,
     77
   ],
   [
     8.175643089894143,
     78
   ],
   [
     8.175643089894143,
     79
   ],
   [
     8.175643089894143,
     80
   ],
   [
     8.175643089894143,
     81
   ],
   [
     8.175643089894143,
     82
   ],
   [
     8.175643089894143,
     83
   ],
   [
     8.175643089894143,
     84
   ],
   [
     8.175643089894143,
     85
   ],
   [
     8.175643089894143,
     86
   ],
   [
     8.175643089894143,
     87
   ],
   [
     8.175643089894143,
     88
   ],
   [
     8.175643089894143,
     89
   ],
   [
     8.175643089894143,
     90
   ],
   [
     8.175643089894143,
     91
   ],
   [
     8.175643089894143,
     92
   ],
   [
     8.175643089894143,
     93
   ],
   [
     8.175643089894143,
     94
   ],
   [
     8.175643089894143,
     95
   ],
   [
     8.175643089894143,
     96
   ],
   [
     8.175643089894143,
     97
   ],
   [
     8.175643089894143,
     98
   ],
   [
     8.175643089894143,
     99
   ],
   [
     8.175643089894143,
     100
   ],
   [
     8.175643089894143,
     101
   ],
   [
     8.175643089894143,
     102
   ],
   [
     8.175643089894143,
     103
   ],
   [
     8.175643089894143,
     104
   ],
   [
     8.175643089894143,
     105
   ],
   [
     8.175643089894143,
     106
   ],
   [
     8.175643089894143,
     107
   ],
   [
     8.175643089894143,
     108
   ],
   [
     8.175643089894143,
     109
   ],
   [
     8.175643089894143,
     110
   ],
   [
     8.175643089894143,
     111
   ],
   [
     8.175643089894143,
     112
   ],
   [
     8.175643089894143,
     113
   ],
   [
     8.175643089894143,
     114
   ],
   [
     8.175643089894143,
     115
   ],
   [
     8.175643089894143,
     116
   ],
   [
     8.175643089894143,
     117
   ],
   [
     8.175643089894143,
     118
   ],
   [
     8.175643089894143,
     119
   ],
   [
     8.175643089894143,
     120
   ],
   [
     8.175643089894143,
     121
   ],
   [
     8.175643089894143,
     122
   ],
   [
     8.175643089894143,
     123
   ],
   [
     8.175643089894143,
     124
   ],
   [
     8.175643089894143,
     125
   ],
   [
     8.175643089894143,
     126
   ],
   [
     8.175643089894143,
     127
   ],
   [
     8.175643089894143,
     128
   ],
   [
     8.175643089894143,
     129
   ],
   [
     8.175643089894143,
     130
   ],
   [
     8.175643089894143,
     131
   ],
   [
     8.175643089894143,
     132
   ],
   [
     8.175643089894143,
     133
   ],
   [
     8.175643089894143,
     134
   ],
   [
     8.175643089894143,
     135
   ],
   [
     8.175643089894143,
     136
   ],
   [
     8.175643089894143,
     137
   ],
   [
     8.175643089894143,
     138
   ],
   [
     8.175643089894143,
     139
   ],
   [
     8.175643089894143,
     140
   ],
   [
     8.175643089894143,
     141
   ],
   [
     8.175643089894143,
     142
   ],
   [
     8.175643089894143,
     143
   ],
   [
     8.175643089894143,
     144
   ],
   [
     8.175643089894143,
     145
   ],
   [
     8.175643089894143,
     146
   ],
   [
     8.175643089894143,
     147
   ],
   [
     8.175643089894143,
     148
   ],
   [
     8.175643089894143,
     149
   ],
   [
     8.175643089894143,
     150
   ],
   [
     8.175643089894143,
     151
   ],
   [
     8.175643089894143,
     152
   ],
   [
     8.175643089894143,
     153
   ],
   [
     8.175643089894143,
     154
   ],
   [
     8.175643089894143,
     155
   ],
   [
     8.175643089894143,
     156
   ],
   [
     8.175643089894143,
     157
   ],
   [
     8.175643089894143,
     158
   ],
   [
     8.175643089894143,
     159
   ],
   [
     8.175643089894143,
     160
   ],
   [
     8.175643089894143,
     161
   ],
   [
     8.175643089894143,
     162
   ],
   [
     8.175643089894143,
     163
   ],
   [
     8.175643089894143,
     164
   ],
   [
     8.175643089894143,
     165
   ],
   [
     8.175643089894143,
     166
   ],
   [
     8.175643089894143,
     167
   ],
   [
     8.175643089894143,
     168
   ],
   [
     8.175643089894143,
     169
   ],
   [
     8.175643089894143,
     170
   ],
   [
     8.175643089894143,
     171
   ],
   [
     8.175643089894143,
     172
   ],
   [
     8.175643089894143,
     173
   ],
   [
     8.175643089894143,
     174
   ],
   [
     8.175643089894143,
     175
   ],
   [
     8.175643089894143,
     176
   ],
   [
     8.175643089894143,
     177
   ],
   [
     8.175643089894143,
     178
   ],
   [
     8.175643089894143,
     179
   ],
   [
     8.175643089894143,
     180
   ],
   [
     8.175643089894143,
     181
   ],
   [
     8.175643089894143,
     182
   ],
   [
     8.175643089894143,
     183
   ],
   [
     8.175643089894143,
     184
   ],
   [
     8.175643089894143,
     185
   ],
   [
     8.175643089894143,
     186
   ],
   [
     8.175643089894143,
     187
   ],
   [
     8.175643089894143,
     188
   ],
   [
     8.175643089894143,
     189
   ],
   [
     8.175643089894143,
     190
   ],
   [
     8.175643089894143,
     191
   ],
   [
     8.175643089894143,
     192
   ],
   [
     8.175643089894143,
     193
   ],
   [
     8.175643089894143,
     194
   ],
   [
     8.175643089894143,
     195
   ],
   [
     8.175643089894143,
     196
   ],
   [
     8.175643089894143,
     197
   ],
   [
     8.175643089894143,
     198
   ],
   [
     8.175643089894143,
     199
   ],
   [
     8.175643089894143,
     200
   ],
   [
     8.175643089894143,
     201
   ],
   [
     8.175643089894143,
     202
   ],
   [
     8.175643089894143,
     203
   ],
   [
     8.175643089894143,
     204
   ],
   [
     8.175643089894143,
     205
   ],
   [
     8.175643089894143,
     206
   ],
   [
     8.175643089894143,
     207
   ],
   [
     8.175643089894143,
     208
   ],
   [
     8.175643089894143,
     209
   ],
   [
     8.175643089894143,
     210
   ],
   [
     8.175643089894143,
     211
   ],
   [
     8.175643089894143,
     212
   ],
   [
     8.175643089894143,
     213
   ],
   [
     8.175643089894143,
     214
   ],
   [
     8.175643089894143,
     215
   ],
   [
     8.175643089894143,
     216
   ],
   [
     8.175643089894143,
     217
   ],
   [
     8.175643089894143,
     218
   ],
   [
     8.175643089894143,
     219
   ],
   [
     8.175643089894143,
     220
   ],
   [
     8.175643089894143,
     221
   ],
   [
     8.175643089894143,
     222
   ],
   [
     8.175643089894143,
     223
   ],
   [
     8.175643089894143,
     224
   ],
   [
     8.175643089894143,
     225
   ],
   [
     8.175643089894143,
     226
   ],
   [
     8.175643089894143,
     227
   ],
   [
     8.175643089894143,
     228
   ],
   [
     8.175643089894143,
     229
   ],
   [
     8.175643089894143,
     230
   ],
   [
     8.175643089894143,
     231
   ],
   [
     8.175643089894143,
     232
   ],
   [
     8.175643089894143,
     233
   ],
   [
     8.175643089894143,
     234
   ],
   [
     8.175643089894143,
     235
   ],
   [
     8.175643089894143,
     236
   ],
   [
     8.175643089894143,
     237
   ],
   [
     8.175643089894143,
     238
   ],
   [
     8.175643089894143,
     239
   ],
   [
     8.175643089894143,
     240
   ],
   [
     8.175643089894143,
     241
   ],
   [
     8.175643089894143,
     242
   ],
   [
     8.175643089894143,
     243
   ],
   [
     8.175643089894143,
     244
   ],
   [
     8.175643089894143,
     245
   ],
   [
     8.175643089894143,
     246
   ],
   [
     8.175643089894143,
     247
   ],
   [
     8.175643089894143,
     248
   ],
   [
     8.175643089894143,
     249
   ],
   [
     8.175643089894143,
     250
   ],
   [
     8.175643089894143,
     251
   ],
   [
     8.175643089894143,
     252
   ],
   [
     8.175643089894143,
     253
   ],
   [
     8.175643089894143,
     254
   ],
   [
     8.175643089894143,
     255
   ],
   [
     8.175643089894143,
     256
   ],
   [
     8.175643089894143,
     257
   ],
   [
     8.175643089894143,
     258
   ],
   [
     8.175643089894143,
     259
   ],
   [
     8.175643089894143,
     260
   ],
   [
     8.175643089894143,
     261
   ],
   [
     8.175643089894143,
     262
   ],
   [
     8.175643089894143,
     263
   ],
   [
     8.175643089894143,
     264
   ],
   [
     8.175643089894143,
     265
   ],
   [
     8.175643089894143,
     266
   ],
   [
     8.175643089894143,
     267
   ],
   [
     8.175643089894143,
     268
   ],
   [
     8.175643089894143,
     269
   ],
   [
     8.175643089894143,
     270
   ],
   [
     8.175643089894143,
     271
   ],
   [
     8.175643089894143,
     272
   ],
   [
     8.175643089894143,
     273
   ],
   [
     8.175643089894143,
     274
   ],
   [
     8.175643089894143,
     275
   ],
   [
     8.175643089894143,
     276
   ],
   [
     8.175643089894143,
     277
   ],
   [
     8.175643089894143,
     278
   ],
   [
     8.175643089894143,
     279
   ],
   [
     8.175643089894143,
     280
   ],
   [
     8.175643089894143,
     281
   ],
   [
     8.175643089894143,
     282
   ],
   [
     8.175643089894143,
     283
   ],
   [
     8.175643089894143,
     284
   ],
   [
     8.175643089894143,
     285
   ],
   [
     8.175643089894143,
     286
   ],
   [
     8.175643089894143,
     287
   ],
   [
     8.175643089894143,
     288
   ],
   [
     8.175643089894143,
     289
   ],
   [
     8.175643089894143,
     290
   ],
   [
     8.175643089894143,
     291
   ],
   [
     8.175643089894143,
     292
   ],
   [
     8.175643089894143,
     293
   ],
   [
     8.175643089894143,
     294
   ],
   [
     8.175643089894143,
     295
   ],
   [
     8.175643089894143,
     296
   ],
   [
     8.175643089894143,
     297
   ],
   [
     8.175643089894143,
     298
   ],
   [
     8.175643089894143,
     299
   ],
   [
     8.175643089894143,
     300
   ],
   [
     8.175643089894143,
     301
   ],
   [
     8.175643089894143,
     302
   ],
   [
     8.175643089894143,
     303
   ],
   [
     8.175643089894143,
     304
   ],
   [
     8.175643089894143,
     305
   ],
   [
     8.175643089894143,
     306
   ],
   [
     8.175643089894143,
     307
   ],
   [
     8.175643089894143,
     308
   ],
   [
     8.175643089894143,
     309
   ],
   [
     8.175643089894143,
     310
   ],
   [
     8.175643089894143,
     311
   ],
   [
     8.175643089894143,
     312
   ],
   [
     8.175643089894143,
     313
   ],
   [
     8.175643089894143,
     314
   ],
   [
     8.175643089894143,
     315
   ],
   [
     8.175643089894143,
     316
   ],
   [
     8.175643089894143,
     317
   ],
   [
     8.175643089894143,
     318
   ],
   [
     8.175643089894143,
     319
   ],
   [
     8.175643089894143,
     320
   ],
   [
     8.175643089894143,
     321
   ],
   [
     8.175643089894143,
     322
   ],
   [
     8.175643089894143,
     323
   ],
   [
     8.175643089894143,
     324
   ],
   [
     8.175643089894143,
     325
   ],
   [
     8.175643089894143,
     326
   ],
   [
     8.175643089894143,
     327
   ],
   [
     8.175643089894143,
     328
   ],
   [
     8.175643089894143,
     329
   ],
   [
     8.175643089894143,
     330
   ],
   [
     8.175643089894143,
     331
   ],
   [
     8.175643089894143,
     332
   ],
   [
     8.175643089894143,
     333
   ],
   [
     8.175643089894143,
     334
   ],
   [
     8.175643089894143,
     335
   ],
   [
     8.175643089894143,
     336
   ],
   [
     8.175643089894143,
     337
   ],
   [
     8.175643089894143,
     338
   ],
   [
     8.175643089894143,
     339
   ],
   [
     8.175643089894143,
     340
   ],
   [
     8.175643089894143,
     341
   ],
   [
     8.175643089894143,
     342
   ],
   [
     8.175643089894143,
     343
   ],
   [
     8.175643089894143,
     344
   ],
   [
     8.175643089894143,
     345
   ],
   [
     8.175643089894143,
     346
   ],
   [
     8.175643089894143,
     347
   ],
   [
     8.175643089894143,
     348
   ],
   [
     8.175643089894143,
     349
   ],
   [
     8.175643089894143,
     350
   ],
   [
     8.175643089894143,
     351
   ],
   [
     8.175643089894143,
     352
   ],
   [
     8.175643089894143,
     353
   ],
   [
     8.175643089894143,
     354
   ],
   [
     8.175643089894143,
     355
   ],
   [
     8.175643089894143,
     356
   ],
   [
     8.175643089894143,
     357
   ],
   [
     8.175643089894143,
     358
   ],
   [
     8.175643089894143,
     359
   ],
   [
     8.175643089894143,
     360
   ]
 ],
 "maximum_speed_polygon": [
   [
     18.8,
     0
   ],
   [
     18.8,
     1
   ],
   [
     18.8,
     2
   ],
   [
     18.8,
     3
   ],
   [
     18.8,
     4
   ],
   [
     18.8,
     5
   ],
   [
     18.8,
     6
   ],
   [
     18.8,
     7
   ],
   [
     18.8,
     8
   ],
   [
     18.8,
     9
   ],
   [
     18.8,
     10
   ],
   [
     18.8,
     11
   ],
   [
     18.8,
     12
   ],
   [
     18.8,
     13
   ],
   [
     18.8,
     14
   ],
   [
     18.8,
     15
   ],
   [
     18.8,
     16
   ],
   [
     18.8,
     17
   ],
   [
     18.8,
     18
   ],
   [
     18.8,
     19
   ],
   [
     18.8,
     20
   ],
   [
     18.8,
     21
   ],
   [
     18.8,
     22
   ],
   [
     18.8,
     23
   ],
   [
     18.8,
     24
   ],
   [
     18.8,
     25
   ],
   [
     18.8,
     26
   ],
   [
     18.8,
     27
   ],
   [
     18.8,
     28
   ],
   [
     18.8,
     29
   ],
   [
     18.8,
     30
   ],
   [
     18.8,
     31
   ],
   [
     18.8,
     32
   ],
   [
     18.8,
     33
   ],
   [
     18.8,
     34
   ],
   [
     18.8,
     35
   ],
   [
     18.8,
     36
   ],
   [
     18.8,
     37
   ],
   [
     18.8,
     38
   ],
   [
     18.8,
     39
   ],
   [
     18.8,
     40
   ],
   [
     18.8,
     41
   ],
   [
     18.8,
     42
   ],
   [
     18.8,
     43
   ],
   [
     18.8,
     44
   ],
   [
     18.8,
     45
   ],
   [
     18.8,
     46
   ],
   [
     18.8,
     47
   ],
   [
     18.8,
     48
   ],
   [
     18.8,
     49
   ],
   [
     18.8,
     50
   ],
   [
     18.8,
     51
   ],
   [
     18.8,
     52
   ],
   [
     18.8,
     53
   ],
   [
     18.8,
     54
   ],
   [
     18.8,
     55
   ],
   [
     18.8,
     56
   ],
   [
     18.8,
     57
   ],
   [
     18.8,
     58
   ],
   [
     18.8,
     59
   ],
   [
     18.8,
     60
   ],
   [
     18.8,
     61
   ],
   [
     18.8,
     62
   ],
   [
     18.8,
     63
   ],
   [
     18.8,
     64
   ],
   [
     18.8,
     65
   ],
   [
     18.8,
     66
   ],
   [
     18.8,
     67
   ],
   [
     18.8,
     68
   ],
   [
     18.8,
     69
   ],
   [
     18.8,
     70
   ],
   [
     18.8,
     71
   ],
   [
     18.8,
     72
   ],
   [
     18.8,
     73
   ],
   [
     18.8,
     74
   ],
   [
     18.8,
     75
   ],
   [
     18.8,
     76
   ],
   [
     18.8,
     77
   ],
   [
     18.8,
     78
   ],
   [
     18.8,
     79
   ],
   [
     18.8,
     80
   ],
   [
     18.8,
     81
   ],
   [
     18.8,
     82
   ],
   [
     18.8,
     83
   ],
   [
     18.8,
     84
   ],
   [
     18.8,
     85
   ],
   [
     18.8,
     86
   ],
   [
     18.8,
     87
   ],
   [
     18.8,
     88
   ],
   [
     18.8,
     89
   ],
   [
     18.8,
     90
   ],
   [
     18.8,
     91
   ],
   [
     18.8,
     92
   ],
   [
     18.8,
     93
   ],
   [
     18.8,
     94
   ],
   [
     18.8,
     95
   ],
   [
     18.8,
     96
   ],
   [
     18.8,
     97
   ],
   [
     18.8,
     98
   ],
   [
     18.8,
     99
   ],
   [
     18.8,
     100
   ],
   [
     18.8,
     101
   ],
   [
     18.8,
     102
   ],
   [
     18.8,
     103
   ],
   [
     18.8,
     104
   ],
   [
     18.8,
     105
   ],
   [
     18.8,
     106
   ],
   [
     18.8,
     107
   ],
   [
     18.8,
     108
   ],
   [
     18.8,
     109
   ],
   [
     18.8,
     110
   ],
   [
     18.8,
     111
   ],
   [
     18.8,
     112
   ],
   [
     18.8,
     113
   ],
   [
     18.8,
     114
   ],
   [
     18.8,
     115
   ],
   [
     18.8,
     116
   ],
   [
     18.8,
     117
   ],
   [
     18.8,
     118
   ],
   [
     18.8,
     119
   ],
   [
     18.8,
     120
   ],
   [
     18.8,
     121
   ],
   [
     18.8,
     122
   ],
   [
     18.8,
     123
   ],
   [
     18.8,
     124
   ],
   [
     18.8,
     125
   ],
   [
     18.8,
     126
   ],
   [
     18.8,
     127
   ],
   [
     18.8,
     128
   ],
   [
     18.8,
     129
   ],
   [
     18.8,
     130
   ],
   [
     18.8,
     131
   ],
   [
     18.8,
     132
   ],
   [
     18.8,
     133
   ],
   [
     18.8,
     134
   ],
   [
     18.8,
     135
   ],
   [
     18.8,
     136
   ],
   [
     18.8,
     137
   ],
   [
     18.8,
     138
   ],
   [
     18.8,
     139
   ],
   [
     18.8,
     140
   ],
   [
     18.8,
     141
   ],
   [
     18.8,
     142
   ],
   [
     18.8,
     143
   ],
   [
     18.8,
     144
   ],
   [
     18.8,
     145
   ],
   [
     18.8,
     146
   ],
   [
     18.8,
     147
   ],
   [
     18.8,
     148
   ],
   [
     18.8,
     149
   ],
   [
     18.8,
     150
   ],
   [
     18.8,
     151
   ],
   [
     18.8,
     152
   ],
   [
     18.8,
     153
   ],
   [
     18.8,
     154
   ],
   [
     18.8,
     155
   ],
   [
     18.8,
     156
   ],
   [
     18.8,
     157
   ],
   [
     18.8,
     158
   ],
   [
     18.8,
     159
   ],
   [
     18.8,
     160
   ],
   [
     18.8,
     161
   ],
   [
     18.8,
     162
   ],
   [
     18.8,
     163
   ],
   [
     18.8,
     164
   ],
   [
     18.8,
     165
   ],
   [
     18.8,
     166
   ],
   [
     18.8,
     167
   ],
   [
     18.8,
     168
   ],
   [
     18.8,
     169
   ],
   [
     18.8,
     170
   ],
   [
     18.8,
     171
   ],
   [
     18.8,
     172
   ],
   [
     18.8,
     173
   ],
   [
     18.8,
     174
   ],
   [
     18.8,
     175
   ],
   [
     18.8,
     176
   ],
   [
     18.8,
     177
   ],
   [
     18.8,
     178
   ],
   [
     18.8,
     179
   ],
   [
     18.8,
     180
   ],
   [
     18.8,
     181
   ],
   [
     18.8,
     182
   ],
   [
     18.8,
     183
   ],
   [
     18.8,
     184
   ],
   [
     18.8,
     185
   ],
   [
     18.8,
     186
   ],
   [
     18.8,
     187
   ],
   [
     18.8,
     188
   ],
   [
     18.8,
     189
   ],
   [
     18.8,
     190
   ],
   [
     18.8,
     191
   ],
   [
     18.8,
     192
   ],
   [
     18.8,
     193
   ],
   [
     18.8,
     194
   ],
   [
     18.8,
     195
   ],
   [
     18.8,
     196
   ],
   [
     18.8,
     197
   ],
   [
     18.8,
     198
   ],
   [
     18.8,
     199
   ],
   [
     18.8,
     200
   ],
   [
     18.8,
     201
   ],
   [
     18.8,
     202
   ],
   [
     18.8,
     203
   ],
   [
     18.8,
     204
   ],
   [
     18.8,
     205
   ],
   [
     18.8,
     206
   ],
   [
     18.8,
     207
   ],
   [
     18.8,
     208
   ],
   [
     18.8,
     209
   ],
   [
     18.8,
     210
   ],
   [
     18.8,
     211
   ],
   [
     18.8,
     212
   ],
   [
     18.8,
     213
   ],
   [
     18.8,
     214
   ],
   [
     18.8,
     215
   ],
   [
     18.8,
     216
   ],
   [
     18.8,
     217
   ],
   [
     18.8,
     218
   ],
   [
     18.8,
     219
   ],
   [
     18.8,
     220
   ],
   [
     18.8,
     221
   ],
   [
     18.8,
     222
   ],
   [
     18.8,
     223
   ],
   [
     18.8,
     224
   ],
   [
     18.8,
     225
   ],
   [
     18.8,
     226
   ],
   [
     18.8,
     227
   ],
   [
     18.8,
     228
   ],
   [
     18.8,
     229
   ],
   [
     18.8,
     230
   ],
   [
     18.8,
     231
   ],
   [
     18.8,
     232
   ],
   [
     18.8,
     233
   ],
   [
     18.8,
     234
   ],
   [
     18.8,
     235
   ],
   [
     18.8,
     236
   ],
   [
     18.8,
     237
   ],
   [
     18.8,
     238
   ],
   [
     18.8,
     239
   ],
   [
     18.8,
     240
   ],
   [
     18.8,
     241
   ],
   [
     18.8,
     242
   ],
   [
     18.8,
     243
   ],
   [
     18.8,
     244
   ],
   [
     18.8,
     245
   ],
   [
     18.8,
     246
   ],
   [
     18.8,
     247
   ],
   [
     18.8,
     248
   ],
   [
     18.8,
     249
   ],
   [
     18.8,
     250
   ],
   [
     18.8,
     251
   ],
   [
     18.8,
     252
   ],
   [
     18.8,
     253
   ],
   [
     18.8,
     254
   ],
   [
     18.8,
     255
   ],
   [
     18.8,
     256
   ],
   [
     18.8,
     257
   ],
   [
     18.8,
     258
   ],
   [
     18.8,
     259
   ],
   [
     18.8,
     260
   ],
   [
     18.8,
     261
   ],
   [
     18.8,
     262
   ],
   [
     18.8,
     263
   ],
   [
     18.8,
     264
   ],
   [
     18.8,
     265
   ],
   [
     18.8,
     266
   ],
   [
     18.8,
     267
   ],
   [
     18.8,
     268
   ],
   [
     18.8,
     269
   ],
   [
     18.8,
     270
   ],
   [
     18.8,
     271
   ],
   [
     18.8,
     272
   ],
   [
     18.8,
     273
   ],
   [
     18.8,
     274
   ],
   [
     18.8,
     275
   ],
   [
     18.8,
     276
   ],
   [
     18.8,
     277
   ],
   [
     18.8,
     278
   ],
   [
     18.8,
     279
   ],
   [
     18.8,
     280
   ],
   [
     18.8,
     281
   ],
   [
     18.8,
     282
   ],
   [
     18.8,
     283
   ],
   [
     18.8,
     284
   ],
   [
     18.8,
     285
   ],
   [
     18.8,
     286
   ],
   [
     18.8,
     287
   ],
   [
     18.8,
     288
   ],
   [
     18.8,
     289
   ],
   [
     18.8,
     290
   ],
   [
     18.8,
     291
   ],
   [
     18.8,
     292
   ],
   [
     18.8,
     293
   ],
   [
     18.8,
     294
   ],
   [
     18.8,
     295
   ],
   [
     18.8,
     296
   ],
   [
     18.8,
     297
   ],
   [
     18.8,
     298
   ],
   [
     18.8,
     299
   ],
   [
     18.8,
     300
   ],
   [
     18.8,
     301
   ],
   [
     18.8,
     302
   ],
   [
     18.8,
     303
   ],
   [
     18.8,
     304
   ],
   [
     18.8,
     305
   ],
   [
     18.8,
     306
   ],
   [
     18.8,
     307
   ],
   [
     18.8,
     308
   ],
   [
     18.8,
     309
   ],
   [
     18.8,
     310
   ],
   [
     18.8,
     311
   ],
   [
     18.8,
     312
   ],
   [
     18.8,
     313
   ],
   [
     18.8,
     314
   ],
   [
     18.8,
     315
   ],
   [
     18.8,
     316
   ],
   [
     18.8,
     317
   ],
   [
     18.8,
     318
   ],
   [
     18.8,
     319
   ],
   [
     18.8,
     320
   ],
   [
     18.8,
     321
   ],
   [
     18.8,
     322
   ],
   [
     18.8,
     323
   ],
   [
     18.8,
     324
   ],
   [
     18.8,
     325
   ],
   [
     18.8,
     326
   ],
   [
     18.8,
     327
   ],
   [
     18.8,
     328
   ],
   [
     18.8,
     329
   ],
   [
     18.8,
     330
   ],
   [
     18.8,
     331
   ],
   [
     18.8,
     332
   ],
   [
     18.8,
     333
   ],
   [
     18.8,
     334
   ],
   [
     18.8,
     335
   ],
   [
     18.8,
     336
   ],
   [
     18.8,
     337
   ],
   [
     18.8,
     338
   ],
   [
     18.8,
     339
   ],
   [
     18.8,
     340
   ],
   [
     18.8,
     341
   ],
   [
     18.8,
     342
   ],
   [
     18.8,
     343
   ],
   [
     18.8,
     344
   ],
   [
     18.8,
     345
   ],
   [
     18.8,
     346
   ],
   [
     18.8,
     347
   ],
   [
     18.8,
     348
   ],
   [
     18.8,
     349
   ],
   [
     18.8,
     350
   ],
   [
     18.8,
     351
   ],
   [
     18.8,
     352
   ],
   [
     18.8,
     353
   ],
   [
     18.8,
     354
   ],
   [
     18.8,
     355
   ],
   [
     18.8,
     356
   ],
   [
     18.8,
     357
   ],
   [
     18.8,
     358
   ],
   [
     18.8,
     359
   ],
   [
     18.8,
     360
   ]
 ],
 "forecast": null,
 "weather": {
   "wave_height": 20,
   "swell_height": 2.2,
   "wave_period": 9.31,
   "swell_period": 9,
   "wave_direction": 210,
   "swell_direction": 233,
   "wind_speed": 110,
   "wind_direction": 45,
   "current_speed": 12,
   "current_direction": 90
 }
}

export const legendData =  [
 { color: '#C77832', label: 'High Acceleration Force Zone' },
 { color: 'rgba(244, 172, 237, 0.9)', label: 'Parametric Roll Zone' },
 { color: '#aad5ce', label: 'Safe Zone' },
 { color: '#DEE8F6', label: 'Speed Constraint Zone' },
 { color: 'rgba(134, 56, 229, 1)', label: 'Wind' },
 { color: 'rgba(60, 206, 197, 1)', label: 'Wave' },
 { color: 'rgba(255, 172, 28, 1)', label: 'Swell' },
];

export const legendDataExtended = [
  legendData[0],
  { color: 'rgba(132, 84, 214, 0.7)', label: 'Heavy Rolling Zone' },
  ...legendData.slice(1)
]

export enum PolarChartEvents {
  PolarPlotRecalculate = "polar-plot-recalculate",
  SelectedView = "view-changed",
  LoadSuccess = "load-success",
  PolarPlotReset = "polar-plot-reset",
  ActiveImminentRisk = "active-imminent-risk",
}

export const dispatchTogglePolarPlotMarkerEvent = ({
    showMarker,
    position,
    nearestEta
}: {
    showMarker: boolean
    position: Coordinate | null
    nearestEta: string | null
}) => {
    VesselPlanningModel!.dispatchEvent(
        new CustomEvent(PlanEvents.TOGGLE_POLAR_PLOT_MARKER, {
            detail: {
                showMarker,
                position,
                nearestEta
            },
        }),
    )
}
